//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/AnimationDesigner.js";
import "../no/Builder.js";
import "../no/SelectNXObject.js";
import "../no/SelectNXObjectList.js";
import "../no/SelectObject.js";
import "../no/SelectObjectList.js";
let d=[[[0,"Color",1,0],[0,"ColorOption",1,0],[1,"FollowerAxis",0,"SelectNXObject",0],[1,"FollowerFaces",0,"SelectNXObjectList",0],[1,"MasterAxis",0,"SelectNXObject",0],[1,"MasterFaces",0,"SelectNXObjectList",0],[0,"Name",1,0]],[],[]];
SPLM.AnimationDesigner.MechanicalCamBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.AnimationDesigner.MechanicalCamBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.AnimationDesigner.MechanicalCamBuilder.ColorOptions = Object.freeze({
    "SpecifyColor" : "SpecifyColor", "NoColor" : "NoColor"});

export default SPLM;